var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('table',{ref:"tableactivity",staticClass:"table table-hover w-100"},[_vm._m(0),_c('tbody')])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Modul")]),_c('th',[_vm._v("Keterangan")]),_c('th',[_vm._v("User")]),_c('th',[_vm._v("Waktu")])])])
}]

export { render, staticRenderFns }